import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/invoices/generar-pago", "documento": "invoices", "acceso": "sesion", "filas": ["025"], "cita": "prod:Areas/Invoices/Controllers/GenerateController.cs:112"} satisfies RutaProd;
